export const MARRIED_MARITAL_STATUS_ID = 3;
